import { clsx } from "clsx";
import { useId, useMemo } from "react";
import { TableSortingControls } from "@/hooks/common/table/use-table-controls";
import { Button } from "../../Button";
import { Icon, IconName } from "../../Icon";

type Props = Readonly<
  TableSortingControls & {
    children?: React.ReactNode;
    labelledBy?: string;
  }
>;

export const TableSort = ({ children, onChange, isActive, direction, labelledBy }: Props) => {
  const actionId = useId();
  const icon = useMemo<IconName>(() => {
    if (!isActive) {
      return "SortBy";
    }

    return direction === "asc" ? "ShortArrowDown" : "ShortArrowUp";
  }, [isActive, direction]);

  return (
    <>
      {children}
      <Button
        variant="unstyled"
        className="!min-h-[auto] !w-fit !p-0"
        aria-label={labelledBy ? undefined : "Ordenar"}
        aria-labelledby={labelledBy ? `${actionId} ${labelledBy}` : undefined}
        onClick={onChange}
      >
        {labelledBy && (
          <span id={actionId} className="sr-only">
            Ordenar por
          </span>
        )}
        <Icon name={icon} className={clsx({ "!text-primary": isActive })} />
      </Button>
    </>
  );
};
